import { render, staticRenderFns } from "./IcoEmails.vue?vue&type=template&id=54166f08&scoped=true"
import script from "./IcoEmails.vue?vue&type=script&lang=js"
export * from "./IcoEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54166f08",
  null
  
)

export default component.exports